import {Injectable} from '@angular/core';
import {PageResult} from '../store/base.graphql';

@Injectable({
  providedIn: 'root',
})
export class PaginationService {
  page:PageResult;
  customPages: any = {}

  constructor() {}

  setPage(page, entity: string = null){
    if (entity) {
      this.customPages[entity] = page;
    } else {
      this.page = page;
    }
  }

  getPage(entity: string = null){
    return  entity ? this.customPages[entity]: this.page;
  }
}
